//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/NXObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"IsBlanked",0,0],[0,"LabelPMI",0,0],[0,"Name",0,0],[0,"NaturalFrequency",0,0],[0,"NaturalFrequencyIndex",0,0],[0,"ResultComponent",0,0],[0,"ResultMeasureType",0,0],[0,"ResultValueType",0,0],[0,"UserSetName",0,0],[1,"Value",0,"Expression",0]],[[[],"Blank",{},0,0],[[],"Unblank",{},0,0],[["validationTag"],"PopulateValidation",{},1,0],[["numObjects","displayableObject"],"GetSelectedObjects",{},0,0]],[]];
SPLM.DesignSimulation.ResultMeasure = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.ResultMeasure";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;